import { lazy, useMemo } from 'react';
import { getModelName, getTableNameSingular } from '../action-utils';

const AgGridActionForm = (props) => {
  const { tableName } = props || {};

  const modelName = useMemo(
    () => getModelName(getTableNameSingular(tableName)),
    [tableName]
  );

  const Component = useMemo(
    () => lazy(() => import(`../Forms/${modelName}Form`)),
    [modelName]
  );

  return <Component {...props} />;
};

export default AgGridActionForm;
